import {
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel
} from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { tableHeadRowSx } from "../../enums/Styles";
const cells = [
  { id: "title", title: "Title", align: "left", width: 30, sortable: true },
  {
    id: "category",
    title: "Category",
    align: "center",
    width: 30,
    sortable: true,
  },
  {
    id: "fileType",
    title: "FileType",
    align: "center",
    width: 30,
    sortable: true,
  },
  {
    id: "dateOfUpload",
    title: "DateOfUpload",
    align: "center",
    width: 30,
    sortable: true,
  },
  {
    id: "service",
    title: "Service",
    align: "center",
    width: 30,
    sortable: true,
  },
  {
    id: "appointment",
    title: "Appointment",
    align: "center",
    width: 30,
  },
  {
    id: "actions",
    title: "Actions",
    align: "center",
    width: 30,
  },
];
export default function FileTableHead({ order, orderBy, onRequestSort }) {
  const { t } = useTranslation();

  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow sx={tableHeadRowSx}>
        {cells.map((cell) => (
          <TableCell
            key={cell.id}
            align={cell.align}
            sx={{
              width: cell.width,
              position: "sticky",
              top: 0,
              zIndex: 1,
            }}
            sortDirection={orderBy === cell.id ? order : false}
          >
            {cell.sortable ? (
              <TableSortLabel
                active={orderBy === cell.id}
                direction={orderBy === cell.id ? order : ""}
                onClick={createSortHandler(cell.id)}
              >
                {t(cell.title)}
              </TableSortLabel>
            ) : (
              t(cell.title)
            )}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
